import * as Sentry from '@sentry/react';
import { buildClientSentryOptions } from './utils/sentryOptions';
import { scrubSentryEvent } from './utils/sentryScrub';

const sentryOptions = buildClientSentryOptions(process.env.REACT_APP_SENTRY_DSN, process.env.NODE_ENV);

export const sentryEnabled = sentryOptions != null;

if (sentryOptions) {
  Sentry.init({
    ...sentryOptions,
    // Defaults wrap fetch/XHR and turn on tracing and replay. Keep uncaught errors only.
    defaultIntegrations: false,
    integrations: [
      Sentry.globalHandlersIntegration(),
      Sentry.linkedErrorsIntegration(),
      Sentry.dedupeIntegration(),
      Sentry.eventFiltersIntegration(),
      Sentry.functionToStringIntegration(),
    ],
    beforeSend(event) {
      return scrubSentryEvent(event);
    },
  });
}
